import Swal from 'sweetalert2'

export function init(parent) {
    parent.querySelectorAll("[confirm-with-sweet-alert='true']").forEach(el => {
        el.addEventListener("click", function (event) {
            event.stopPropagation();
            Swal.fire({
                text: CONFIG.i18n.CONFIRM,
                icon: "error",
                theme: 'dark',
                showCancelButton: true,
                confirmButtonText: CONFIG.i18n.yes,
                cancelButtonText: CONFIG.i18n.no
            }).then((result) => {
                if (result.isConfirmed) {
                    htmx.trigger(event.target, "confirmed");
                }
            });
        });
    });
}

/**
 * Global listener for showing HTML dialog via HTMX trigger
 *
 * Usage from backend:
 * response = HttpResponse(...)
 * response['HX-Trigger'] = json.dumps({
 *     'swal:show': {
 *         'html': '<div>Your HTML content</div>',
 *         'icon': 'success',  // optional: success, error, warning, info, question
 *         'title': 'Success!',  // optional
 *         'confirmButtonText': 'OK',  // optional
 *         'showConfirmButton': True,  // optional, default True
 *     }
 * })
 * return response
 */
document.addEventListener('swal:show', (event) => {
    const { html, icon, title, confirmButtonText, showConfirmButton = true } = event.detail;

    Swal.fire({
        html: html,
        icon: icon || undefined,
        title: title || undefined,
        confirmButtonText: confirmButtonText || 'OK',
        showConfirmButton: showConfirmButton,
        customClass: {
            popup: 'bg-[#0d0d0d]! border! border-gray-700! w-3xl!',
            title: 'text-white!',
            htmlContainer: 'text-gray-200!',
            container: 'z-[99999]!',
            confirmButton: 'bg-red-600! hover:bg-red-700! text-white! font-semibold! py-2! px-4! rounded-md!',
        },
        background: '#0d0d0d',
        color: '#e5e7eb',
    });
});

/**
 * Global listener for modal close events
 */
document.addEventListener('modal:close', (event) => {
    const modalElement = event.target.closest('[data-modal-backdrop]');
    if (modalElement) {
        modalElement.dispatchEvent(new Event('close.modal'));
    }
});